import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { getForm } from './add-sector-target-form.element';
import { DFormGroup } from '../../types';
import { IDFormControl } from '../../d-form/d-form.helpers';
import { TrainingPartnerService } from 'projects/services/src/app/API/training-partner.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { ActivatedRoute } from '@angular/router';
declare var toastr: any;
@Component({
	selector: 'app-add-sector-target-form',
	templateUrl: './add-sector-target-form.component.html',
	styleUrls: ['./add-sector-target-form.component.css']
})
export class AddSectorTargetFormComponent implements OnInit, OnChanges {
	addSectorTargetForm: DFormGroup;
	@Output() submit = new EventEmitter();
	@Output() cancel = new EventEmitter();
	@Output() control = new EventEmitter();
	@Input() selectedSchemeId: string;
	@Input() sectorTargetTable: any;
	@Input() trainingCentreName: any;
	@Input() selectedCourses = [];
	formControl: IDFormControl;
	sectors;
	options: any;
	routerParams: any;
	constructor(
		private trainingPartnerService: TrainingPartnerService,
		private activatedRoute: ActivatedRoute,
	) { 
		this.activatedRoute.params.subscribe(res => {
			this.routerParams = res;
		})
	}

	ngOnInit() {
   this.options = {
      sectors: [
      ],
      courses: [
      ],
      trainingCentreName: this.trainingCentreName,
    };
		this.options.trainingCentreName = this.trainingCentreName;
		this.trainingPartnerService.getSelectedSchemeSectors(this.selectedSchemeId, undefined, {
			onlyApproved: true
		}).subscribe(({ data }) => {
			data = data || [];
			this.sectors = data.map(sector => ({
				name: sector.name,
				value: sector
			}));
			Helpers.copyArray(this.options.sectors, this.sectors);
		});
		this.addSectorTargetForm = getForm(this.options, {
			sectorChange: this.onSectorChange.bind(this),
		});
	}

	onSubmit(data) {
		this.resetForm();
		this.submit.emit(data);
	}

	resetForm() {
		this.formControl.reset();
		this.formControl.patchValues({
			trainingCentreName: this.trainingCentreName,
		});
	}

	onCancel(data) {
		this.resetForm();
		this.cancel.emit(data);
	}

	onControlChange($event) {
		this.formControl = $event;
		this.control.emit(this.formControl);

	}

	onSectorChange(val) {
		this.trainingPartnerService.getSelectedSchemeCoursesV2(this.selectedSchemeId, null, {
			backEndQuery: {
				sectorID: val.sectorReferenceId,
				forJSS: this.routerParams.forJSS && this.routerParams.forJSS === 'true' ? true : false,
			}
		})
			.subscribe(({ data }) => {
				data = data || [];
				const selectedCoursesNames = this.selectedCourses.map(res => (res && res.course));
				const selectedCourseUniqueID = this.selectedCourses.map(res => (res && res.uniqueID));

				const courses = data.map(courseData => ({
					name: courseData.course,
					value: courseData
				})).filter(
					// result => !selectedCoursesNames.includes(result && result.name
					result => !selectedCourseUniqueID.includes(result && result.value && result.value.uniqueID
					));
				console.log(this.options.courses, courses);
				Helpers.copyArray(this.options.courses, courses);
				if (this.options.courses && this.options.courses.length && this.options.courses.length === 0) {
					toastr.error('All Courses has been added already for this Sector!')
				}
			});
	}

	ngOnChanges() {
		if (this.sectorTargetTable && this.sectors && this.sectorTargetTable.data && this.sectorTargetTable.data.length !== 0) {
			this.sectorTargetTable.data.filter((res, i) => {
				// const index = this.sectors.findIndex(ress => ress.name === res.sectorName);
				// const index = this.sectors.findIndex(ress => ress.name === res.sectorName);
				// if (index !== -1) {
				// 	this.sectors.splice(index, 1);
				// }
			});
		}
		console.log(this.options.sectors, this.sectors);
		Helpers.copyArray(this.options.sectors, this.sectors);
	}

}
